import React from 'react';
import config from '../dummy_data/configuration.json';


const ProductListItem = ({item}) => (
    <div className="product-list-item">
        <a href={`#/productdetail/${item.ID}`} target="_blank" title={item.Name}>
            <img src={config.rootSite + item.Image} alt={item.Name} />
        </a>

        <div className="product-intro" style={{"backgroundImage": `url(${require('../img/bg-course.png')})`}}>
            <h2><a href={`#/productdetail/${item.ID}`} title={item.Name} target="_blank">{item.Name}</a></h2>
            <p>{item.Trait}</p>
        </div>

        {/*
            <div class="moco-course-bottom">
                <span class="l color-red">TAG：<a href="http://www.zfgroup.com.cn/tag/%e5%87%8f%e5%8e%8b%e9%98%80" rel="tag">减压阀</a></span> <span class="r">7月前</span>
            </div>
        */}
    </div>
);



const ProductList = ({items}) => {
    return (
        <div className="product-list-items">
            {
                items.map((n, i) => {
                    return(<ProductListItem key={i} item={n} />);
                })
            }
        </div>
    );
}

export default ProductList;


// WEBPACK FOOTER //
// ./src/components/ProductList.js